import styled from 'styled-components';

import { commonMaxWidth, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const ProposalQuestion = styled.div`
    width: 100%;
    padding: 4rem 0 15rem;
    background-color: ${COLORS.gray50};

    ${respondDown(Breakpoints.md)`
        padding: 1.6rem 0;
    `}
`;

export const BackTo = styled.div`
    display: flex;
    column-gap: 1.6rem;
    align-items: center;
    margin-bottom: 5rem;
`;

export const Id = styled.div`
    font-size: 1.6rem;
    line-height: 2.8rem;
    color: ${COLORS.textSecondary};
    opacity: 0.7;
    margin-bottom: 0.4rem;
`;

export const QuestionText = styled.h3`
    font-size: 5.6rem;
    line-height: 6.4rem;

    color: ${COLORS.textPrimary};

    ${respondDown(Breakpoints.md)`
        font-size: 4rem;
        line-height: 4.5rem;
        margin-bottom: 3.2rem;
    `}
`;

export const ProposalSection = styled.div`
    padding: 6rem 0 0 4rem;
    width: 100%;
    ${commonMaxWidth};

    ${respondDown(Breakpoints.md)`
        padding: 3.2rem 1.6rem 0;
    `}
`;

export const LeftContent = styled.div`
    max-width: 78rem;

    ${respondDown(Breakpoints.lg)`
        max-width: 58.2rem;
      `}

    ${respondDown(Breakpoints.md)`
        max-width: unset;
    `}
`;

export const Title = styled.h5`
    font-size: 2rem;
    line-height: 2.8rem;
    color: ${COLORS.textPrimary};
    margin-bottom: 1rem;
`;

export const TabNav = styled.div`
    background-color: ${COLORS.gray50};
    position: sticky;
    top: 0;
    z-index: 1;
    width: 100%;

    ${respondDown(Breakpoints.md)`
        display: none;
    `}
`;

export const TabNavContent = styled.div`
    ${commonMaxWidth};
    padding-left: 4rem;
    display: flex;
    width: 100%;
`;

export const TabNavItem = styled.div<{ $active?: boolean }>`
    padding: 1.7rem 0 1.3rem;
    color: ${({ $active }) => ($active ? COLORS.purple500 : COLORS.textGray)};
    font-weight: ${({ $active }) => ($active ? 700 : 400)};
    border-bottom: ${({ $active }) =>
        $active ? `0.1rem solid ${COLORS.purple500} ` : `0.1rem solid ${COLORS.transparent}`};
    cursor: pointer;

    &:hover {
        border-bottom: 0.1rem solid ${COLORS.purple500};
        color: ${COLORS.purple500};
    }

    &:not(:last-child) {
        margin-right: 2.5rem;
    }
`;
